import { useState } from "react";

import { Stack } from "ui/stack";
import Link from "components/partials/link/link";
import { Typography } from "ui/typography";

const TruncatedText = ({
  text,
  noOfLines = 4,
  initialTruncate = true,
  textAlign = "left",
}: {
  text: string;
  noOfLines: number;
  initialTruncate: boolean;
  textAlign?: "left" | "right";
}) => {
  const [isTruncated, setIsTruncated] = useState(initialTruncate);

  return (
    <Stack
      className="content"
      sx={{ mb: "0.25rem", fontSize: "0.75rem" }}
      data-testid="truncate-text"
    >
      {text.length < 125 ? (
        <Typography variant="inherit" component="span" sx={{ textAlign }}>
          {text}
        </Typography>
      ) : isTruncated ? (
        <>
          <Typography
            variant="inherit"
            component="span"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: noOfLines,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}>
            {text}
          </Typography>
          <Link
            sx={{ textDecoration: "underline", mt: 0.5 }}
            onClick={() => setIsTruncated(false)}>
            Show More
          </Link>
        </>
      ) : (
        <>
          <Typography variant="inherit" component="span">
            {text}
          </Typography>
          <Link
            sx={{ textDecoration: "underline", mt: 0.5 }}
            onClick={() => setIsTruncated(true)}>
            Show Less
          </Link>
        </>
      )}
    </Stack>
  );
};

export default TruncatedText;
